(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('urbrand-youtube-banner')) {
    customElements.define('urbrand-youtube-banner', class extends HTMLElement {
      connectedCallback() {
        this.template = this.querySelector('template');
        if (!this.template) return;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.update = () => this.renderVideo();
        this.mobile.addEventListener('change', this.update);
        this.reducedMotion.addEventListener('change', this.update);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.visible = true;
              this.observer.disconnect();
              this.renderVideo();
            }
          });
          this.observer.observe(this);
        } else {
          this.visible = true;
          this.renderVideo();
        }
      }
      renderVideo() {
        const blocked = this.dataset.mobile === 'false' && this.mobile.matches;
        const current = this.querySelector('iframe');
        if (blocked || !this.visible) {
          current?.remove();
          return;
        }
        const frame = this.template.content.querySelector('iframe').cloneNode(true);
        const url = new URL(frame.getAttribute('src'));
        if (this.reducedMotion.matches) url.searchParams.set('autoplay', '0');
        frame.src = url.toString();
        if (current?.src === frame.src) return;
        current?.remove();
        this.appendChild(frame);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.mobile?.removeEventListener('change', this.update);
        this.reducedMotion?.removeEventListener('change', this.update);
        this.querySelector('iframe')?.remove();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
